<template>
  <div
    id="home"
    v-if="userName"
  >
    <div class="home-page">
      <!-- <span class="icon-number entericon" @click="flag=!flag"></span> -->

      <header
        class="home-header"
        height="56px"
      >
        <el-menu
          mode="horizontal"
          @select="handleSelect"
          height="56px"
          :default-active="headerMeunActiveIndex"
          router
        >
          <span class="home_logo">
            <img
              src="../assets/imgs/logo.png"
              class="logo2"
            />
          </span>
          <div class="home_logotxt">
            后台管理
          </div>
          <template
            v-for="(item,index) in headerMeunData"
            style="display:inline;"
          >
            <el-menu-item
              :key="item.id"
              :index="numToString(index + 1)"
              :route="{'path':item.link}"
            >{{item.text}}
            </el-menu-item>
          </template>
        </el-menu>
        <div class="dropdown">
          <el-row class="block-col-2">
            <el-col :span="12">
              <el-dropdown @command="headerCommand">
                <span class="el-dropdown-link el-dropdown-link2">
                  <span class="icon-number"></span>
                  {{userName}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="ChangePassword">修改密码</el-dropdown-item>
                  <el-dropdown-item command="Logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </div>
      </header>
      <section class="home-container">
        <div class="aside">
          <el-menu
            :default-active="asideMeunActiveIndex"
            class="el-menu-vertical-demo"
            :collapse="isCollapse"
            :default-openeds="defaultOpeneds"
            @select="asideHandleSelect"
            @open="handleOpen"
            @close="handleClose"
            active-text-color="#fb435b"
            router
          >
            <template v-for="(item,index) in activeAsideMenuData">
              <el-submenu
                :index="numToString(index)"
                :key="item.id"
                class="aside_title"
              >
                <template slot="title">
                  <span
                    v-if="item.icon"
                    :class="item.icon"
                    style="padding: 8px 8px 8px 0; font-size:16px;"
                  ></span>
                  <span>{{ item.title }}</span>
                </template>
                <el-menu-item-group>
                  <!-- :disabled="!child.disabled" -->
                  <el-menu-item
                    :disabled="!child.disabled"
                    class="item_list"
                    style="padding-left:47px;"
                    v-for="(child,no) in item.child"
                    :key="child.id"
                    :index="`${index}-${no}`"
                    :route="{path:child.routerLink}"
                  >
                    {{child.title}}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </template>
            <span class="pabottom"></span>
          </el-menu>
        </div>
        <div class="home-content">
          <!-- <router-view></router-view> -->
          <!-- <el-collapse-transition> -->
          <keep-alive :include="keepAliveInclude">
            <router-view></router-view>
          </keep-alive>
          <!-- </el-collapse-transition> -->
        </div>
      </section>
      <!-- <footer class="home-footer" height="30px"> -->
      <Bottom></Bottom>
      <!-- </footer> -->
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogFormVisible"
      width="540px"
    >
      <el-form
        :model="form"
        ref="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item
          label="原密码"
          prop="oldPassword"
        >
          <el-input
            type="password"
            v-model.trim="form.oldPassword"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPassword"
        >
          <el-input
            type="password"
            v-model.trim="form.newPassword"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <div class="pretendRequired">
          <el-form-item
            label="确认密码"
            prop="confirmNew"
          >
            <el-input
              type="password"
              v-model.trim="form.confirmNew"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Bottom from '@/components/bottom'
import { rap, fetch, hasAuthority } from '@/utils/common.js'
let url = {
  profile: '/fep/pc/user/profile',
  logout: '/fep/pc/logout',
  changePassword: '/fep/pc/user/changePassword'
}
url = rap(url)

const asideMenuData = [
  [
    {
      title: '工作台',
      icon: 'icon-work red',
      child: [{
        title: '工作台',
        routerLink: '/workbench',
        disabled: hasAuthority('pc_index')
      }]
    }
  ],
]
export default {
  data() {
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请再一次输入新密码'))
      } else {
        if (!(/^\w{6,16}$/.test(value))) {
          return callback(new Error('只支持由数字、26个英文字母或者下划线，长度最少6位、最多16位'))
        } else if (this.form.newPassword !== this.form.confirmNew) {
          return callback(new Error('新密码与确认密码不相同'))
        } else {
          callback()
        }
      }
    }
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmNew: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { pattern: /^\w{6,16}$/, message: '只支持由数字、26个英文字母或者下划线，长度最少6位、最多16位' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^\w{6,16}$/, message: '只支持由数字、26个英文字母或者下划线，长度最少6位、最多16位' }
        ],
        confirmNew: [
          { validator: checkPassword, trigger: 'change' }
        ]
      },
      dialogFormVisible: false,
      isCollapse: false,
      defaultOpeneds: ['0', '1'],
      headerMeunActiveIndex: '',
      asideMeunActiveIndex: '0-0',
      activeAsideMenuData: asideMenuData[0],
      flag: false,
      stateIndex: 0,
      headerMeunData: [
        {
          text: '首页',
          link: '/home'
        }
      ],
      userName: null,
      to: null,
      keepAliveInclude: []
    }
  },
  created() {
    this.keepAliveInclude = [this.$route.path.split('/')[1]]
    this.flag = window.localStorage.getItem('isFirstTimeLogin') === 'true'
    this.fetchProfile()
  },
  mounted() {
    let index = this.headerMeunData.findIndex(item => {
      console.log('+ this.$route.matched', this.$route.matched, 'item.link', item.link)
      if (item.link === '/home' && this.$route.matched[0].path === '') {
        return true
      }
      return item.link === this.$route.matched[0].path
    })
    this.headerMeunActiveIndex = this.numToString(index + 1)
    //this.changeHeaderMeunActiveIndex()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //alert('submit!')
          this.fetchChangePassword()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    headerCommand(command) {
      switch (command) {
        case 'ChangePassword':
          //this.$message('click on item ' + command)
          this.dialogFormVisible = true
          this.form.oldPassword = ''
          this.form.newPassword = ''
          this.form.confirmNew = ''
          break
        case 'Logout':
          this.fetchLogout()
          break
        default:
          this.$message('nothing' + command)
      }
    },
    fetchChangePassword() {
      fetch(url.changePassword, this.form).then(res => {
        if (res.status === 200) {
          this.$message({
            message: res.message,
            type: 'success'
          })
        }
        this.dialogFormVisible = false
        this.$router.replace({ path: '/login' })
      })
    },
    fetchProfile() {
      fetch(url.profile).then(res => {
        this.userName = res.data.name
      })
    },
    fetchLogout() {
      fetch(url.logout).then(res => {
        this.$message({
          message: res.message,
          type: 'success'
        })
        this.$router.replace({ path: '/login' })
      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.headerMeunActiveIndex = this.numToString(key)
    },
    numToString(val) {
      return String(val)
    },
    generateArr(length) {
      console.log(this.headerMeunActiveIndex, 'generate')
      if (this.headerMeunActiveIndex === '4') {
        return []
      }
      let arr = []
      for (let i = 0; i <= length; i++) {
        arr.push(String(i))
      }
      return arr
    },
    handleOpen(key, keyPath) {
      console.log('open', key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log('close', key, keyPath)
    },
    asideHandleSelect(key, keyPath) {
      console.log(key, keyPath, 'asideHandleSelect')
      console.log(this.$route.matched, 'asideHandleSelect')
      this.asideMeunActiveIndex = this.numToString(key)
    },
    changeHeaderMeunActiveIndex(val) {
      console.log(val, 'changeHeaderMeunActiveIndex ~~')
      this.activeAsideMenuData = asideMenuData[val - 1]
      let index2, index3
      this.activeAsideMenuData.forEach((element, elementIndex) => {
        let no = element.child.findIndex(item => {
          if (this.$route.matched.length > 1) {
            let reg = new RegExp(`^(${item.routerLink})`)
            return reg.test(this.$route.matched[1].path)
          }
        })
        if (no >= 0) {
          index2 = elementIndex
          index3 = no
          this.asideMeunActiveIndex = `${index2}-${index3}`
        }
      })
      this.defaultOpeneds = val === '4' ? [index2 + ''] : this.generateArr(this.activeAsideMenuData.length)
    }
  },
  watch: {
    headerMeunActiveIndex(val) {
      this.changeHeaderMeunActiveIndex(val)
    },
    '$route'(to, from) {
      this.keepAliveInclude = [to.path.split('/')[1]]
      this.to = to
      let index = this.headerMeunData.findIndex(item => {
        if (item.link === '/home' && this.$route.matched[0].path === '') {
          return true
        }
        return item.link === to.matched[0].path
      })
      // console.log(this.headerMeunActiveIndex, String(index + 1))
      if (this.headerMeunActiveIndex === String(index + 1)) {
        this.headerMeunActiveIndex = this.numToString(index + 1)
        this.changeHeaderMeunActiveIndex(this.headerMeunActiveIndex)
      } else {
        this.headerMeunActiveIndex = this.numToString(index + 1)
      }
    }
  },
  components: {
    Bottom
  }
}
</script>

<style lang="scss" scoped>
#home {
  position: relative;
  .entericon {
    cursor: pointer;
    font-size: 50px;
    position: absolute;
    z-index: 15;
    position: absolute;
    top: 46px;
    right: 18px;
    border-radius: 50%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }
  .entericon2 {
    right: 290px;
    content: url("../assets/imgs/star.png");
  }
  .enter {
    width: 280px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: $bg_color;
    z-index: 5;
    position: absolute;
    top: 0px;
    right: 0px;
    height: 100%;
    .enter_title {
      font-size: 16px;
      text-indent: 15px;
      padding: 19px 0;
      color: $theme_color;
      border-bottom: 1px solid $border_color;
    }
    .enter_des {
      line-height: 1.5;
      padding: 20px 15px 10px 15px;
      font-size: 14px;
    }
    .enter_list {
      color: $black_color;
      font-size: 16px;
      cursor: pointer;
      padding: 12px;
      margin-bottom: 10px;
      .enter_list_href {
        float: right;
        color: $shallowgray_color;
        font-size: 20px;
        padding-right: 10px;
      }
      .enter_list_href2 {
        color: $theme_color;
      }
    }
    .enter_list:hover,
    .enter_list:hover .enter_list_href {
      background-color: #fff5f7;
      color: $theme_color;
    }
    .enter_list2 {
      background-color: #fff5f7;
      color: $theme_color;
    }
  }
}
.el-dropdown-link2 {
  font-size: 14px;
  .icon-number {
    font-size: 16px;
    vertical-align: middle;
    padding-right: 5px;
  }
}
.logo2 {
  vertical-align: middle;
}
.el-menu-item {
  height: 56px;
  line-height: 56px;
}
#home {
  height: 100%;
  .home-page {
    height: 100%;
  }
  & > .el-container.is-vertical {
    height: 100%;
  }
  .el-menu-item.is-disabled {
    opacity: 0.25;
    cursor: not-allowed;
    background: none !important;
  }
  .home-header {
    padding: 0;
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 56px;
  }
  .home-container {
    font-size: 0;
    height: calc(100% - 102px);
    border-bottom: 16px solid #f5f5f5;
  }
  .home-footer {
    margin-top: 16px;
    padding: 0;
    background-color: $bg_color;
    text-align: left;
    line-height: 56px;
    height: 30px;
  }
  .el-menu--horizontal .el-menu-item {
    //height: 56px;
    list-style: 56px;
  }
  .home-content {
    display: inline-block;
    vertical-align: top;
    background: #f5f5f5;
    width: calc(100% - 230px);
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 14px;
  }
  .aside {
    display: inline-block;
    vertical-align: top;
    height: 100%;
    width: 220px;
    overflow-x: hidden;
    //overflow-y: auto;
    .el-menu-item {
      height: 46px;
      line-height: 46px;
    }
    .el-menu-item.is-active {
      background: #fff5f7;
      border-left: 2px solid $theme_color;
    }
  }

  body > .home-header {
    margin-bottom: 40px;
    overflow-y: hidden;
  }
  .home-header {
    background: linear-gradient(
      100deg,
      rgb(251, 67, 91) 0%,
      rgb(255, 132, 0) 100%
    );
    position: relative;
  }
}
.el-menu--horizontal {
  z-index: 5;
  // background: linear-gradient( 100deg, rgb(251,67,91) 0%, rgb(255,132,0) 100%);
  background: rgba(0, 0, 0, 0);
  width: 1200px;
}
a.home_logotxt-link {
  text-decoration: underline;
  color: #fff;
  font-size: 12px;
  margin-left: 10px;
}
.home_logotxt {
  color: #fff;
  float: left;
  font-size: 16px;
  height: 56px;
  line-height: 56px;
  padding-left: 20px;
  margin-right: 20px;
  position: relative;
  outline: none;

  &::after {
    content: "";
    border-left: 1px solid #fff;
    height: 20px;
    position: absolute;
    left: 0;
    top: 19px;
  }
}
.home_logo {
  display: inline-block;
  width: 190px;
  float: left;
  box-sizing: border-box;
  padding: 0 140px 0 64px;
  color: $bg_color;
  font-weight: bold;
  font-size: 16px;
}
.el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: $bg_color;
}
.dropdown {
  position: absolute;
  top: 0px;
  right: 44px;
  .el-dropdown-link {
    color: #fff;
  }
}
[class*=" el-icon-"],
[class^="el-icon-"] {
  padding-left: 8px;
  display: inline;
}
.pabottom {
  //position: fixed;
  //bottom: 0;
  display: inline-block;
  height: 50px;
}
</style>